import { defineMessages } from 'react-intl';

import AudioEdit from './AudioEdit';
import AudioView from './AudioView';

import audioHorizontalSVG from '@plone/volto/icons/audio.svg';

defineMessages({
  audio: {
    id: 'Audio',
    defaultMessage: 'Audio',
  },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.audioBlock = {
    id: 'audioBlock',
    title: 'Audio',
    group: 'media',
    icon: audioHorizontalSVG,
    view: AudioView,
    edit: AudioEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };
  return config;
};

export default applyConfig;
